<template>
  <v-layout wrap>
    <in-text v-model="selectedItem.responsible_worker_name" label="Responsable de la Remediación" md="4" :view_only="view_only"/>

    <in-select :value.sync="responsible_area_name" label="Área Responsable de la Remediación" md="4" :items="c_items" :null_val="true" :view_only="view_only"/>
    <in-text v-if="responsible_area_name=='Otro'" v-model="selectedItem.responsible_area_name" label="Área Responsable de la Remediación" md="4" :view_only="view_only"/>
    <v-flex md4></v-flex>
  </v-layout>
</template>

<script>
import filter from '@/components/mixins/filter';
import inSelect2 from './in-select2.vue';
export default {
  components: { inSelect2 },
  props:{'view_only':{default:false},'selectedItem':{default:()=>({responsible_worker_name:null,responsible_area_name:null})}},
  mixins:[filter],
  data() {
    return {
      responsible_area_name:'',
      items:[],
      rq_name:'in-responsible-user',
    };
  },
  computed: {
    c_items(){ return this.items.concat(['Otro']) }
  },
  watch:{
    'responsible_area_name'(v){
      this.selectedItem.responsible_area_name = v == 'Otro'? '':v;
    },
    'selectedItem.responsible_area_name'(v){
      if (this.responsible_area_name != 'Otro') this.responsible_area_name = v;
    }
  },
  created(){
    this.responsible_area_name = this.selectedItem.responsible_area_name;
    this.get_rows();
  },
  methods: {
    get_rows(){
      this.requests.getsSimple['remediation_plannings/areas/a/all']()
        .then(r => {
          this.items = (r || []);
          return r
        });
    },
  }
};
</script>
